(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fundlet-checkout-guard"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__fundletCheckoutGuardInstalled) return;
    window.__fundletCheckoutGuardInstalled = true;

    const guard = document.getElementById('FundletCheckoutGuard');
    if (!guard) return;

    const dialog = guard.querySelector('[role="dialog"]');
    const heading = guard.querySelector('#FundletCheckoutGuardHeading');
    const message = guard.querySelector('#FundletCheckoutGuardMessage');
    const secondaryButton = guard.querySelector('[data-fundlet-guard-secondary]');
    const defaultHeading = heading.textContent;
    const defaultMessage = message.textContent;
    const defaultSecondaryText = secondaryButton.textContent;
    let previousFocus = null;
    let busy = false;

    const value = (input) => typeof input === 'string' ? input.trim() : '';
    const selectionIsActive = () => {
      try {
        const campaign = value(sessionStorage.getItem('fundlet_shop_site_campaign'));
        const participant = value(sessionStorage.getItem('fundlet_shop_site_participant'));
        const expires = Number(sessionStorage.getItem('fundlet_shop_site_expiry'));

        return Boolean(campaign && participant && (!Number.isFinite(expires) || expires === 0 || expires > Date.now()));
      } catch (_) {
        return false;
      }
    };
    const cartIsAttributed = (cart) => {
      if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return false;

      let campaign = '';
      let participant = '';

      return cart.items.every((item) => {
        const properties = item && item.properties ? item.properties : {};
        const itemCampaign = value(properties.Campaign);
        const itemParticipant = value(properties.Participant);

        if (!itemCampaign || !itemParticipant) return false;
        if (!campaign) campaign = itemCampaign;
        if (!participant) participant = itemParticipant;

        return itemCampaign === campaign && itemParticipant === participant;
      });
    };

    const openGuard = (customMessage, customHeading, customSecondaryText) => {
      previousFocus = document.activeElement;
      heading.textContent = customHeading || defaultHeading;
      message.textContent = customMessage || defaultMessage;
      secondaryButton.textContent = customSecondaryText || defaultSecondaryText;
      guard.hidden = false;
      document.body.style.overflow = 'hidden';
      dialog.focus();
    };

    const closeGuard = () => {
      guard.hidden = true;
      document.body.style.overflow = '';
      if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
    };

    const continueToCheckout = (trigger) => {
      if (trigger.tagName === 'A') {
        window.location.assign(trigger.href);
        return;
      }

      const form = trigger.form || trigger.closest('form');
      if (!form) {
        window.location.assign('/checkout');
        return;
      }

      const checkoutField = document.createElement('input');
      checkoutField.type = 'hidden';
      checkoutField.name = 'checkout';
      checkoutField.value = 'checkout';
      form.appendChild(checkoutField);
      HTMLFormElement.prototype.submit.call(form);
    };

    const validateCheckout = async (event, trigger) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (busy || trigger.disabled) return;

      busy = true;
      trigger.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(guard.dataset.cartUrl, {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { Accept: 'application/json' },
        });
        if (!response.ok) throw new Error(guard.dataset.validationError);

        const cart = await response.json();
        if (!cartIsAttributed(cart)) {
          openGuard();
          return;
        }

        continueToCheckout(trigger);
      } catch (error) {
        openGuard(error instanceof Error ? error.message : guard.dataset.validationError);
      } finally {
        busy = false;
        trigger.removeAttribute('aria-busy');
      }
    };

    document.addEventListener('click', (event) => {
      const addTrigger = event.target.closest('button[name="add"], input[name="add"]');
      if (addTrigger && !window.Shopify?.designMode && !selectionIsActive()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openGuard(guard.dataset.addMessage, guard.dataset.addHeading, guard.dataset.keepBrowsing);
        return;
      }

      const checkoutTrigger = event.target.closest('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]');
      if (checkoutTrigger) validateCheckout(event, checkoutTrigger);
    }, true);

    document.addEventListener('submit', (event) => {
      const trigger = event.submitter;
      const form = event.target;
      const addToCart = trigger?.name === 'add' || /\/cart\/add(?:\.js)?$/.test(form.action);

      if (addToCart && !window.Shopify?.designMode && !selectionIsActive()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        openGuard(guard.dataset.addMessage, guard.dataset.addHeading, guard.dataset.keepBrowsing);
        return;
      }

      if (trigger && trigger.name === 'checkout') validateCheckout(event, trigger);
    }, true);

    guard.addEventListener('click', (event) => {
      if (event.target.closest('[data-fundlet-guard-close]')) closeGuard();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !guard.hidden) closeGuard();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
